import { createSelector } from 'reselect';

import { ERROR_SOURCES } from '../constants/ErrorsConstants';

export const getHelpTopics = (state) => state.helpTopics;
export const getErrors = (state) => state.errors;

export const getIsOpen = createSelector(getHelpTopics, (helpTopics) => helpTopics.isOpen);

export const getCurrentQuestion = createSelector(
  getHelpTopics,
  (helpTopics) => helpTopics.currentQuestion
);

export const getQuestionsAndAnswers = createSelector(
  getHelpTopics,
  (helpTopics) => helpTopics.questionsAndAnswers
);

export const hasHelpTopicsError = createSelector(getErrors, (errors) =>
  errors.some((error) => error?.source === ERROR_SOURCES.HELP_TOPICS)
);
